import React from 'react';
import { Phone, Mail, MessageCircle } from 'lucide-react';
export const Contact = () => {
  return <div className="min-h-screen bg-white py-20" data-id="element-394">
      <div className="container mx-auto px-4" data-id="element-395">
        <div className="max-w-5xl mx-auto" data-id="element-396">
          <div className="text-center mb-16" data-id="element-397">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900" data-id="element-398">
              Get in Touch
            </h1>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-399">
              We're here to help. Contact our support team through any of these
              channels.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-400">
            {/* WhatsApp */}
            <div className="bg-white p-8 flex flex-col items-center text-center border border-gray-100 rounded-lg" data-id="element-401">
              <div className="bg-indigo-100 rounded-full p-6 mb-6" data-id="element-402">
                <MessageCircle className="w-8 h-8 text-indigo-600" strokeWidth={1.5} data-id="element-403" />
              </div>
              <h2 className="text-2xl font-semibold mb-3" data-id="element-404">WhatsApp</h2>
              <p className="text-gray-600 mb-6" data-id="element-405">
                Connect with us instantly via WhatsApp for quick support.
              </p>
              <a href="#" className="mt-auto text-indigo-600 font-medium flex items-center justify-center" data-id="element-406">
                Open WhatsApp <span className="ml-2" data-id="element-407">→</span>
              </a>
            </div>
            {/* Email */}
            <div className="bg-white p-8 flex flex-col items-center text-center border border-gray-100 rounded-lg" data-id="element-408">
              <div className="bg-indigo-100 rounded-full p-6 mb-6" data-id="element-409">
                <Mail className="w-8 h-8 text-indigo-600" strokeWidth={1.5} data-id="element-410" />
              </div>
              <h2 className="text-2xl font-semibold mb-3" data-id="element-411">Email</h2>
              <p className="text-gray-600 mb-6" data-id="element-412">
                Send us an email and we'll get back to you within 24 hours.
              </p>
              <a href="mailto:support@onestop.et" className="mt-auto text-indigo-600 font-medium flex items-center justify-center" data-id="element-413">
                support@onestop.et <span className="ml-2" data-id="element-414">→</span>
              </a>
            </div>
            {/* Phone */}
            <div className="bg-white p-8 flex flex-col items-center text-center border border-gray-100 rounded-lg" data-id="element-415">
              <div className="bg-indigo-100 rounded-full p-6 mb-6" data-id="element-416">
                <Phone className="w-8 h-8 text-indigo-600" strokeWidth={1.5} data-id="element-417" />
              </div>
              <h2 className="text-2xl font-semibold mb-3" data-id="element-418">Phone</h2>
              <p className="text-gray-600 mb-6" data-id="element-419">
                Call us directly for immediate assistance with your inquiries.
              </p>
              <a href="tel:7060" className="mt-auto text-indigo-600 font-medium flex items-center justify-center" data-id="element-420">
                6070 <span className="ml-2" data-id="element-421">→</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>;
};